export default {
  data() {
    return {
      stepsDelivery: ["Подтверждение заказа", "Приготовление", "Ожидание курьера", "Курьер в пути", "Курьер на месте"],
      stepsPickup: ["Подтверждение заказа", "Приготовление", "Отправка в пункт выдачи", "Ожидает в пункте выдачи", "Заказ получен"]
    };
  },
  props: {
    methods: String,
    steps: Number
  },
  mounted() {}
};